//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {supportConnectDevice} from "../../utils/device/deviceConnect";
import {windVane} from '../../utils/tmallGenius';
import saveImgBase64 from '../../items/saveImgBase64.vue'
//
export default {
  components: {saveImgBase64, },
  data() {
    return {
      deviceList: [] //可以添加的控制器设备
    };
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加设备");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {
    //显示有入网添加过程的
    this.deviceList = supportConnectDevice.filter(
      item => (item.deviceGeneralType === "controller_wifi")
        //|| (item.deviceGeneralType === "controller_zigbee")
        //|| (item.deviceGeneralType === "remote_zigbee")
    );
  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  列表点击
    * */
    listClick(obj) {
      this.$router.push({
        path: '/connect/' + obj.connectType + '/turn_on',
        query: {
          name: obj.name,
          deviceGeneralType: obj.deviceGeneralType,
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/DeviceList.vue